const more = () => {
    const moreButton = document.querySelector('.js-more-button');
    const moreContent = document.querySelector('.js-more-content');
    const more = document.querySelector('.js-more');

    // 初期化: 最初の状態を設定
    const initialHeight = window.innerWidth <= 640 ? '184px' : '200px'; // スマホとPCで初期高さを切り替え
    moreContent.style.height = initialHeight; // 閉じた状態の初期高さ
    moreContent.style.overflow = 'hidden'; // スクロールバーを隠す
    moreContent.style.transition = 'height 0.3s ease'; // アニメーション設定

    moreButton.addEventListener('click', () => {
        const isOpen = moreButton.classList.contains('open');

        if (isOpen) {
            // 開いているときに閉じるアニメーション
            const currentHeight = moreContent.scrollHeight; // 現在の高さを取得
            moreContent.style.height = `${currentHeight}px`; // 一旦固定
            requestAnimationFrame(() => {
                moreContent.style.height = initialHeight; // 閉じる高さに設定
            });
        } else {
            // 閉じているときに開くアニメーション
            const fullHeight = moreContent.scrollHeight; // コンテンツ全体の高さを取得
            moreContent.style.height = initialHeight; // 初期状態を設定
            requestAnimationFrame(() => {
                moreContent.style.height = `${fullHeight}px`; // 全体の高さまで展開
            });
        }

        // ボタンとコンテンツのクラス切り替え
        moreButton.classList.toggle('open');
        more.classList.toggle('open');
    });

    // ウィンドウリサイズ時に高さを再設定
    window.addEventListener('resize', () => {
        const newInitialHeight = window.innerWidth <= 640 ? '184px' : '200px';
        if (!moreButton.classList.contains('open')) {
            moreContent.style.height = newInitialHeight;
        }
    });
};

const tableWrap = () => {
    const tables = document.querySelectorAll('table');
    if (tables.length === 0) return;
    tables.forEach((table) => {
        const tableWrap = document.createElement('div');
        tableWrap.classList.add('table-wrap');
        table.parentNode.insertBefore(tableWrap, table);
        tableWrap.appendChild(table);
    });
};

const main = () => {
    if (document.querySelector('#page-column') === null) return;
    more();
    tableWrap();
};

export default main;
